var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CBCB1163-CD40-4002-A3D3-63617D10191D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.0_Creatives_14",
    transform: "translate(-809.000000, -410.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-(2)",
    transform: "translate(741.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8282031,7.8125e-05 L1.171875,7.8125e-05 C0.5246875,7.8125e-05 0,0.524765625 0,1.17195312 L0,31.2970312 C0,31.9442187 0.5246875,32.4689062 1.171875,32.4689062 L12.5521094,32.4689062 L12.5521094,37.6563281 L9.95835938,37.6563281 C9.31117188,37.6563281 8.78648438,38.1810156 8.78648438,38.8282031 C8.78648438,39.4753906 9.31117188,40.0000781 9.95835938,40.0000781 L13.7239844,40.0000781 L26.2760938,40.0000781 L30.0417188,40.0000781 C30.6889063,40.0000781 31.2135938,39.4753906 31.2135938,38.8282031 C31.2135938,38.1810156 30.6889063,37.6563281 30.0417188,37.6563281 L27.4479688,37.6563281 L27.4479688,32.4689062 L38.8282031,32.4689062 C39.4753906,32.4689062 40.0000781,31.9442187 40.0000781,31.2970312 L40.0000781,1.17195312 C40.0000781,0.524765625 39.4753906,7.8125e-05 38.8282031,7.8125e-05 Z M37.6563281,30.1251562 L26.2760938,30.1251562 L13.7239844,30.1251562 L2.34375,30.1251562 L2.34375,2.34382812 L37.6563281,2.34382812 L37.6563281,30.1251562 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3398438,15.2097656 L20.8086719,8.03132812 C20.3560156,7.59992187 19.644375,7.59984375 19.1915625,8.03132812 L11.6603125,15.2097656 C11.3135938,15.5403125 11.2028906,16.0486719 11.3809375,16.4935156 C11.5588281,16.9383594 11.9896875,17.23 12.4688281,17.23 L15.0625781,17.23 L15.0625781,23.5892969 C15.0625781,24.2364844 15.5872656,24.7611719 16.2344531,24.7611719 L23.765625,24.7611719 C24.4128125,24.7611719 24.9375,24.2364844 24.9375,23.5892969 L24.9375,17.23 L27.53125,17.23 C28.0103906,17.23 28.4411719,16.9383594 28.6192188,16.4935156 C28.7972656,16.04875 28.6865625,15.5403906 28.3398438,15.2097656 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/UploadFileIcon.3151cf021346e0295246285053ea4c13.svg";
export { ForwardRef as ReactComponent };